import { defineComponent as _defineComponent } from 'vue'
import EOIRequestForm from "@/components/eoi/EOIRequestForm.vue";
  import {
    ref,
    reactive,
    computed,
    onMounted,
    onUnmounted,
    onBeforeMount,
  } from "vue";
  import store from "@/store";
  import router from "@/router";
  import HeaderCustomer from "@/components/HeaderCustomer.vue";
  import { MaxFileSize } from "@/constants";
  import { LotInterface } from "@/types/LotInterface";
  import { changePrimaryColor } from "@/helpers/customer/changePrimaryColor";
  import { LotStatus } from "@/enums/LotStatus";
  import { POSITION, useToast } from "vue-toastification";
  import { validDocumentsTypes } from "@/helpers/fileUpload";
  import { isLogged } from "@/features/useUser";
  import getUserRole from "@/helpers/getUserRole";
  import { EstateInterface } from "@/types/EstateInterface";
  import { changePrimaryColorEoiViews } from "@/helpers/eoi/changePrimaryColorEoiViews";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'EOIRequest',
  setup(__props, { expose: __expose }) {
  __expose();

  const toast = useToast();
  const isCreateEioError = ref(false);
  const estateId = ref(router.currentRoute.value.params.estateId);
  const stageId = ref(router.currentRoute.value.query?.stageId);
  const lotId = ref(router.currentRoute.value.params.lotId);
  const estate = ref<EstateInterface>({});
  const lot = ref<LotInterface | null>(null);
  const eoiTemplate = ref({});

  const isLotStatusAvailable = computed(() => {
    return (
      lot.value?.status === LotStatus.AVAILABLE ||
      lot.value?.status === LotStatus.HOLD
    );
  });

  const updateIsCreateEoiError = (value: boolean) => {
    isCreateEioError.value = value;
  };
  const businessId = computed(() => {
    return (router.currentRoute.value.query?.businessId as string) ?? null;
  });

  onMounted(async () => {
    await store
      .dispatch("estate/getEstate", {
        id: estateId.value,
        businessId: businessId.value,
      })
      .then((res) => {
        estate.value = res.data;
        changePrimaryColorEoiViews(estate.value, businessId.value);
      });

    const lotAction = isLogged() ? "getLot" : "getOpenLot";

    store.dispatch(`lot/${lotAction}`, lotId.value).then((res) => {
      const allowedLotStatus = [LotStatus.AVAILABLE, LotStatus.HOLD];

      if (!allowedLotStatus.includes(res.data.status)) {
        toast.error("This lot is not available. Please choose another lot", {
          position: POSITION.TOP_LEFT,
        });
        router.replace({
          name: "EstateMap",
          params: { estateId: estate.value._id },
        });
      } else {
        lot.value = res.data;
      }
    });
  });

  const onBack = () => {
    const { backUrl } = router.currentRoute.value.params;

    if (backUrl) {
      router.push(backUrl as string);
    } else {
      router.push(
        `/estate/${estateId.value}?stageId=${
          !stageId.value ? "" : stageId.value
        }`
      );
    }
  };

const __returned__ = { toast, isCreateEioError, estateId, stageId, lotId, estate, lot, eoiTemplate, isLotStatusAvailable, updateIsCreateEoiError, businessId, onBack, EOIRequestForm, ref, reactive, computed, onMounted, onUnmounted, onBeforeMount, get store() { return store }, get router() { return router }, HeaderCustomer, get MaxFileSize() { return MaxFileSize }, get LotInterface() { return LotInterface }, get changePrimaryColor() { return changePrimaryColor }, get LotStatus() { return LotStatus }, get POSITION() { return POSITION }, get useToast() { return useToast }, get validDocumentsTypes() { return validDocumentsTypes }, get isLogged() { return isLogged }, get getUserRole() { return getUserRole }, get EstateInterface() { return EstateInterface }, get changePrimaryColorEoiViews() { return changePrimaryColorEoiViews } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})